var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasuring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m417 21h-402c-5.532 0-10.615 3.045-13.225 7.922-2.61 4.878-2.324 10.796.744 15.398l37.718 56.577 17.789 337.993c1.538 29.221 25.663 52.11 54.924 52.11h203.827c29.472 0 53.604-23.062 54.942-52.503l14.887-327.497h30.394c2.757 0 5 2.243 5 5v130c0 24.813 20.187 45 45 45s45-20.187 45-45v-130c0-52.383-42.618-95-95-95zm-75.249 416.136c-.609 13.381-11.579 23.864-24.974 23.864h-203.827c-13.3 0-24.266-10.404-24.965-23.686l-18.006-342.102c-.142-2.689-1.005-5.292-2.499-7.532l-24.453-36.68h316.275zm140.249-191.136c0 8.271-6.729 15-15 15s-15-6.729-15-15v-130c0-19.299-15.701-35-35-35h-29.03l1.364-30h27.666c35.841 0 65 29.159 65 65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185 131c8.284 0 15-6.716 15-15s-6.716-15-15-15h-50c-8.284 0-15 6.716-15 15v300c0 8.284 6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-30h35c8.284 0 15-6.716 15-15s-6.716-15-15-15h-35v-30h15c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-30h35c8.284 0 15-6.716 15-15s-6.716-15-15-15h-35v-30h15c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasuring);
export default __webpack_public_path__ + "static/media/measuring.10219f3d46a9c463f31d67392731fbf6.svg";
export { ForwardRef as ReactComponent };